/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import history from "helper/history";
import LoginStore from "../stores/loginstore";
import DefaultAutoContainerStore from "../stores/defaultAutoContainerStore";

// /login/passwordpage?user="abc"&userId="def"&reqUrl="/autocontaineraction"
// "/autocontaineraction?"

// Dashboard: http://edelweiss.happay.in/#/genericworkflow/3207336?user=5555532955&userId=HP20201141513335855702904HP&c_code=+91
// WORKFLOW_URL + str(container_type)+'/'+str(resource_id)+'?user='+str(mobile_number)+'&userId='+user_id +'&hasRole=false' + '&c_code='+ str(user.country.dail_extension)
// new URL: autocontaineractionV2?user=8050129904&userId=HP0120312aJK1023012&resource_id=HPR12312312&twfs_id=1234&action=approve&c_code=+91

export default class AutoRedirect {
    constructor(props, isSSO) {
        this._loginStoreChanges = this._loginStoreChanges.bind(this);
        this.autoDirectStatus = false;
        LoginStore.on("change", this._loginStoreChanges);
        this.urlObj = {};
        this.initialUrl = "";
        this.isreqUrl = false;
        this.isSSO = isSSO;
        this.urls = unescape(decodeURIComponent(`${props.pathname}${props.search}`));
        this._handlePageRedirection();
    }

    _loginStoreChanges(type) {
        if (type === "AUTO_DIRECT") {
            if (
                this.urlObj.hasOwnProperty("user") &&
                this.urlObj.hasOwnProperty("userId") &&
                this.urlObj.pushParam
            ) {
                const url = this.urlObj.pushParam;
                history.push(url);
            }
        }
    }

    _handlePageRedirection() {
        /**
         * 2 cases
         * 1. with action_map=
         * 2. with action=
         */
        const urlObj = {};
        if (!urlObj.hasOwnProperty("pushParam")) {
            urlObj.pushParam = null;
        }
        const urlArr = this.urls ? this.urls.split("?") : [];
        if (typeof this.urls === "string" && !this.urls.includes("/login?logout")) {
            // filtering the hash key generated due to history
            const queryArr =
                (urlArr[1] && urlArr[1].split("&").filter(q => !q.startsWith("_"))) || [];

            if (urlArr[1] && urlArr[1].includes("user") && urlArr[1].includes("userId")) {
                if (queryArr && queryArr.length && urlArr[1].indexOf("c_code") === -1) {
                    queryArr.splice(queryArr.length, 0, "c_code=+91");
                }
                if (queryArr && queryArr.length && urlArr[1].indexOf("hasRole") === -1) {
                    queryArr.splice(queryArr.length, 0, "hasRole=false");
                }
            }

            const initialPartOfURL = urlArr[0];
            const queryPartOfURL = queryArr.join("&");
            LoginStore._setField("activeTab", 1);
            for (const key in queryArr) {
                const tempArray = queryArr[key].split("=");
                const name = tempArray[0];
                let value = tempArray[1];

                if (name === "c_code" && !value) {
                    value = "+91";
                }
                if (!urlObj.hasOwnProperty(name)) {
                    urlObj[name] = {};
                }
                urlObj[name] = value;

                if (["user", "userId", "c_code", "emailId"].includes(name)) {
                    LoginStore._setField(name, value);
                    if (name === "emailId") {
                        LoginStore._setField("activeTab", 2);
                        LoginStore._setField("user", value);
                    }
                } else if (name === "reqUrl") {
                    this.isreqUrl = true;
                    urlObj.pushParam = `${value}?${queryPartOfURL}`;
                }
            }

            const completeURL = `${initialPartOfURL}${queryPartOfURL ? `?${queryPartOfURL}` : ""}`;

            if (this.isreqUrl) {
                this.initialUrl = completeURL;
            } else {
                if ("user" in urlObj && "userId" in urlObj) {
                    urlObj.pushParam = completeURL;
                    let loginPage = "/login/passwordpage?";
                    if ("domain_name" in urlObj) {
                        loginPage = `/login/sso?domain_name=${urlObj["domain_name"]}&`;
                    }
                    this.initialUrl = `${loginPage}${queryPartOfURL}&reqUrl=${initialPartOfURL}`;
                    // this.initialUrl = `/login/passwordpage?${queryPartOfURL}&reqUrl=${initialPartOfURL}`;

                    localStorage.setItem("redirectUrl", initialPartOfURL);
                } else {
                    localStorage.setItem("redirectUrl", completeURL);
                }
                localStorage.setItem("isSSO", this.isSSO);
                // Below line is because we previously stored is isSos
                if (localStorage.getItem("isSos")) localStorage.removeItem("isSos");
            }

            if (urlObj.hasOwnProperty("user") && urlObj.hasOwnProperty("userId")) {
                this.autoDirectStatus = true;
                if (this.isSSO || "domain_name" in urlObj) {
                    localStorage.setItem("urlObj", JSON.stringify(urlObj));
                } else {
                    DefaultAutoContainerStore._setUrlObj(urlObj);
                }
            }

            this.urlObj = urlObj;
        }
    }

    _getAutoDirectStatus() {
        return this.autoDirectStatus;
    }

    _getPushParams() {
        return this.urlObj.pushParam;
    }

    _getIntialUrl() {
        // console.log(120, this.initialUrl);
        return this.initialUrl;
    }

    getUserId() {
        return this.urlObj.userId;
    }
}
